export default __webpack_public_path__ + "static/media/LOGOPACO.8fd1ea23.png";